export const SET_USER_LOADING = 'redux/user/SET_USER_LOADING';
export const SET_USER_ERROR = 'redux/user/SET_USER_ERROR';
export const SET_USER = 'redux/user/SET_USER';
export const RESET_USER = 'redux/user/RESET_USER';
export const SET_ATTEMPTED_AUTO_SIGNIN = 'redux/user/SET_ATTEMPTED_AUTO_SIGNIN';
export const SET_ACCOUNT_UNLOCKED = 'redux/user/SET_ACCOUNT_UNLOCKED';
export const UPDATE_USER_PERMISSIONS = 'redux/user/UPDATE_USER_PERMISSIONS';
export const RESET_USER_ERROR = 'redux/user/RESET_USER_ERROR';
export const SET_USER_PREFERENCES = 'redux/user/SET_USER_PREFERENCES';

export const initialState = {
  loading: false,
  user: {},
  error: false,
  attemptedAutoSignin: false,
  unlockKeyGenerated: false,
  accountUnlocked: false,
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case SET_USER_LOADING:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case SET_USER_ERROR:
      return {
        ...state,
        loading: false,
        error: action.data.error,
      };
    case SET_USER:
      return {
        ...state,
        error: false,
        loading: false,
        user: action.data.user,
      };
    case RESET_USER:
      return { ...initialState };
    case SET_ATTEMPTED_AUTO_SIGNIN:
      return {
        ...state,
        attemptedAutoSignin: action.data.attemptedAutoSignin,
      };
    case UPDATE_USER_PERMISSIONS:
      return {
        ...state,
        user: {
          ...state.user,
          permissions: action.data.permissions,
        },
      };
    case SET_ACCOUNT_UNLOCKED:
      return {
        ...state,
        error: action.data.error || '',
        loading: action.data.loading || false,
        unlockKeyGenerated: action.data.unlockKeyGenerated || false,
        accountUnlocked: action.data.accountUnlocked || false,
      };
    case RESET_USER_ERROR:
      return {
        ...state,
        error: false,
      };
    case SET_USER_PREFERENCES:
      return {
        ...state,
        user: {
          ...state.user,
          preferences: action.data.preferences,
        },
      };
    default:
      return state;
  }
};

export default user;
